import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {injectIntl, FormattedMessage} from 'react-intl'
import mxFlag from './mx.svg'
import usFlag from './us.svg'

class LanguageSelector extends Component {
  constructor () {
    super()
    this.state = { useFlags: this.useFlags() }
    this.updateUseFlags = this.updateUseFlags.bind(this)
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateUseFlags)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateUseFlags)
  }

  updateUseFlags () {
    this.setState({ useFlags: this.useFlags() })
  }

  useFlags () {
    return window.innerWidth < 500
  }

  render () {
    const flags = {
      'es-MX': (<img src={mxFlag} className="flag" alt={
        this.props.intl.formatMessage({ id: 'switchToLang' })
      } />),
      'en-US': (<img src={usFlag} className="flag" alt={
        this.props.intl.formatMessage({ id: 'switchToLang' })
      } />),
    }

    const lang = this.props.intl.locale || 'en-US'
    const targetLang = lang === 'en-US' ? 'es-MX' : 'en-US'
    const flag = flags[targetLang]

    const label = this.state.useFlags
      ? flag : <FormattedMessage id="switchToLang" />

    const currentPath = window.location.pathname.toString().replace(`/${lang}`, '')

    return (
      <Link to={`/${targetLang}${currentPath}`} hrefLang={targetLang} rel="alternate">
        {label}
      </Link>
    )
  }
}

export default injectIntl(LanguageSelector)



// WEBPACK FOOTER //
// ./src/LanguageSelector.js